import { render } from "./CardTransfer.vue?vue&type=template&id=71430e24"
import script from "./CardTransfer.vue?vue&type=script&lang=js"
export * from "./CardTransfer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__